<template>
  <router-link :to="{ name: 'City', params: { city: city.name, id:city.id, genre: city.title }}" class="city-card" @click.native="onSelect()">
    <img :src="'http://image.tmdb.org/t/p/w185/' + city.poster_path" alt="" class="city-card__cover">
    <div class="city-card__overlay">
      <div class="city-card__title">{{ city.title }}</div>
      <div class="city-card__subtitle">See the movie</div>
      <div class="city-card__number">{{ city.dorms_count }}</div>
    </div>
    <div class="city-card__cnt">
      <v-link
        class="city-card__button"
        :to="{ name: 'City', params: { city: city.name }}"
        title="Inspect Movie"
      />
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'CityCard',
  props: {
    city: Object
  },
  methods: {
    onSelect() {
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', this.city.name)
      window.localStorage.setItem('genre', this.city.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/city-card";
</style>
